import angular from "angular"
import uiRouter from "angular-ui-router"
import routing from "./surroundings.routes"
import L from "leaflet"
import { MapController } from "../shared/mapcontroller"
export class SurroundingsController extends MapController {
  loadMap() {
    var mapData = {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      lat: this.campsitedata.centerlat,
      lng: this.campsitedata.centerlng,
      defaultzoom: this.campsitedata.defaultzoom,
      maxZoom: this.campsitedata.defaultzoom + 1,
      minZoom: this.campsitedata.defaultzoom - 4,
      zoomControl: true,
      bounceAtZoomLimits: false,
    }

    this.map = L.map("map-aerial", mapData).setView([mapData.lat, mapData.lng], mapData.defaultzoom)
    this.map.zoomControl.setPosition("bottomright")

    let tileLayer = L.tileLayer(mapData.url, {
      attribution: '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
      maxZoom: mapData.maxZoom,
      layerid: "titleimage",
    }).addTo(this.map)

    tileLayer.on("load", () => {
      this.appReady = true
      this.$scope.$apply() // needs a scope apply here as is outside angular scope
      tileLayer.off("load")
    })
  }

  disableInteraction() {
    this.map.dragging.disable()
    this.map.touchZoom.disable()
    this.map.doubleClickZoom.disable()
    this.map.scrollWheelZoom.disable()
    this.map.boxZoom.disable()
    this.map.keyboard.disable()
    if (this.map.tap) this.map.tap.disable()
  }

  addCampsiteMarker() {
    const size = 45
    let campsiteIcon = new L.icon({
      iconUrl: "https://dwf18h5sawogn.cloudfront.net/happycamprassets/markers/tent-marker.png",
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
      className: "leaflet-zoom-hide ",
    })

    let opts = {}
    opts.icon = campsiteIcon
    const campsiteLatLng = [this.campsitedata.centerlat, this.campsitedata.centerlng]

    let campsitemarker = L.marker(campsiteLatLng, opts)

    campsitemarker.on("click", () => {
      let result = { mapid: this.$transition$.params().mapid }
      this.$state.go("mainmap", result)
      //this.disableInteraction();
      //this.map.flyTo(campsiteLatLng, this.campsitedata.currentMapMaxZoom);
    })

    this.map.addLayer(campsitemarker)
  }

  campsiteMarkerClick() {
    let result = { mapid: this.$transition$.params().mapid }
    this.$state.go("mainmap", result)
  }

  getSurroundingsMarkerSaveData() {
    return {}
  }

  addMarkers() {
    let types = [
      {
        type: "surroundings",
        data: this.campsitedata.placesofinterest,
      },
    ]

    this.addAllMarkerTypes(types)

    this.addCampsiteMarker()
  }

  addTransitions() {
    this.map.flyTo([this.campsitedata.centerlat, this.campsitedata.centerlng], this.campsitedata.defaultzoom - 4)
  }
}

export default angular
  .module("makeamapAngularApp.surroundings", ["makeamapAngularApp.auth", uiRouter])
  .config(routing)
  .component("surroundings", {
    bindings: {
      campsitedata: "<",
      $transition$: "<",
    },
    template: require("./surroundings.html"),
    controller: SurroundingsController,
    transclude: false,
  }).name
